<template>
    <el-card>
        <div slot="header">
            <div class="fin-flex fin-justify-between fin-items-center">
                <h1 class="fin-text-blue-800">Merged Dashboards</h1>
            </div>

            <div class="fin-mt-2 fin-space-x-4 fin-flex fin-justify-between fin-items-center">
                <el-input clearable class="fin-rounded" v-model="search" id="name"
                          placeholder="Search..."></el-input>
            </div>
        </div>

        <el-table ref="tableSelections"
                  :data="_.get(collection, 'data', mergedDashboards)"
                  style="width: 100%"
                  :loading="loading"
        >
            <el-table-column prop="name" label="Name" width="100"></el-table-column>
            <el-table-column label="Dashboards">
                <template slot-scope="scope">
                    {{ scope.row.dashboards.join(', ') }}
                </template>
            </el-table-column>
            <el-table-column label="Url">
                <template slot-scope="scope">
                    <a :href="scope.row.url" target="_blank">
                        {{ scope.row.url }}
                    </a>
                </template>
            </el-table-column>
            <el-table-column prop="appearance" label="Theme" width="100"></el-table-column>
            <el-table-column prop="minutes" label="Minutes" width="100"></el-table-column>
            <el-table-column prop="created_at" label="Created At"></el-table-column>
            <el-table-column label="Action" width="150">
                <template slot-scope="scope">
                    <div class="fin-space-x-4">
                        <a @click="editMergedDashboard(scope.row)">
                            <i class="fas fa-eye"></i>
                        </a>

                        <a @click="deleteDashboard(scope.row)">
                            <i class="el-icon-delete fin-text-red-600"></i>
                        </a>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            class="fin-block fin-mt-2"
            v-show="_.get(collection, 'total') > 0"
            :total="_.get(collection, 'total')"
            :page.sync="_.get(collection, 'current_page')"
            :limit.sync="_.get(collection, 'per_page')"
            @pagination="getCollections"
        />

        <x-modal
            v-if="editModal"
            :w-width="1080"
            @cancel="closeModal()"
            @close="closeModal()"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            :ok-text="'Merge Dashboards'"
            @ok="updateDashboard"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                {{ "Edit Merged Dashboard" }}
            </div>

            <div class="container">
                <el-form ref="form"
                         label-width="140px"
                         :model="form"
                         :rules="rules"
                         label-position="top"
                >
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="Name" prop="name">
                                <el-input class="text-capitalize" type="text" id="name" name="name"
                                          v-model="form.name"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Theme" prop="appearance">
                                <el-select class="fin-w-full" name="appearance" id="appearance"
                                           v-model="form.appearance"
                                           clearable
                                           filterable>
                                    <el-option value="black" label="Black">
                                    </el-option>
                                    <el-option value="white" label="White">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="Hide Header" prop="header_hidden">
                                <el-select class="fin-w-full" name="header_hidden" id="header_hidden" v-model="form.header_hidden"
                                           clearable
                                           filterable>
                                    <el-option :value="1"
                                               :selected="form.header_hidden === 1"
                                               :label="'Yes'">
                                    </el-option>
                                    <el-option :value="0"
                                               :selected="form.header_hidden === 0"
                                               :label="'No'">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="Carousel Minutes" prop="minutes">
                                <el-input-number v-model="form.minutes" controls-position="right" :min="0"
                                                 :max="5"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </x-modal>
    </el-card>
</template>

<script>
import Pagination from '@shared/components/pagination'

export default {
    name: 'MergedDashboardIndex',
    components: {
        Pagination,
    },
    props: {
        mergedDashboards: {
            required: false,
            type: [Array]
        }
    },
    data() {
        return {
            collection: [],
            loading: false,
            event: {},
            search: '',
            searchTimeout: null,
            searchTimeoutWait: 1000,
            editModal: false,
            form: {},
            rules: {
                name: [{required: true, message: "Name is required"}],
                appearance: [{required: true, message: "Theme is required"}],
                minutes: [{required: true, message: "Carousel minutes is required"}],
            }
        }
    },
    watch: {
        'search': {
            handler(val) {
                if (val) {
                    let event = {
                        page: 1,
                        limit: 10
                    }

                    if (this.searchTimeout) clearTimeout(this.searchTimeout)
                    this.searchTimeout = setTimeout(() => {
                        this.getCollections(event)
                    }, this.searchTimeoutWait)
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.getCollections()
    },
    methods: {
        closeModal() {
            this.editModal = false
        },
        deleteDashboard(row) {
            this.$tenant.delete("/admin/settings/merged-dashboard/" + _.get(row, 'id') + "/remove")
                .then(res => {
                    this.$message({
                        message: "Merged Dashboard Deleted Successfully",
                        type: "success"
                    });

                    this.getCollections()
                }).catch(error => {
                console.log('deleteDashboard ', error)
            })
        },
        getCollections(event) {
            this.loading = true

            axios.get(`/admin/settings/get-all-merged-dashboards`, {
                params: {
                    page: _.get(event, 'page', 1),
                    per_page: _.get(event, 'limit', 10),
                    search: this.search
                }
            }).then((res) => {
                this.page = _.get(res.data, 'current_page')
                this.event.page = _.get(res.data, 'current_page')
                this.collection = res.data

                this.loading = false
            }).catch((error) => {
                console.log('getCollections ', error)

                this.loading = false
            })
        },
        updateDashboard() {
            this.$refs.form.validate(async (valid, errors) => {
                if (valid) {
                    this.loading = true

                    axios.post("/admin/settings/merged-dashboard/" + this.form.id + "/update", this.form)
                        .then((res) => {
                            this.dashboardData = res.data
                            swal({
                                title: "Success!",
                                type: "success",
                                text: "Merged Dashboard Updated",
                            })

                            this.loading = false
                            this.closeModal()
                        }).catch(error => {
                        console.log('updateDashboard error ', error)

                        this.loading = false
                    })
                }
            })
        },
        editMergedDashboard(row) {
            this.editModal = true
            this.form = row
        }
    }
}
</script>
